import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './pages/counter/counterSlice';
import {
  emptySplitApi,
  graphQLEmptySplitApi,
} from './services/emptySplitApi';
import tokenReducer from './services/tokenSlice';
import authUserReducer from './services/features/authUserSlice';
import alertReducer from './services/alert';
import responseMiddleware from './services/base/responseMiddleware';
import popupReducer from './services/features/popupSlice';
import companyReducer from './services/features/companySlice';
import refreshReducer from './services/features/refreshSlice';
import countryReducer from './services/features/countrySlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    token: tokenReducer,
    authUser: authUserReducer,
    alerts: alertReducer,
    popup: popupReducer,
    company: companyReducer,
    refresh: refreshReducer,
    country: countryReducer,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
    [graphQLEmptySplitApi.reducerPath]:
      graphQLEmptySplitApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      emptySplitApi.middleware,
      graphQLEmptySplitApi.middleware,
      responseMiddleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
